import { AppBar } from '@/components/layout/AppBar'
import { BottomTabBar } from '@/components/layout/BottomTabBar'
import { PageShell } from '@/components/layout/PageShell'
import { config } from '@/config'
import { kidFirstShellEnabled } from '@/content/kid-first'
import { usePlayer } from '@/hooks/player/usePlayer'
import { Suspense, lazy } from 'react'
import { Outlet } from 'react-router'

const InstallBanner = lazy(() =>
  import('@/components/feedback/InstallBanner').then((m) => ({
    default: m.InstallBanner,
  })),
)

const showDiagnostics = import.meta.env.DEV || config.qa.validationEnabled

const PerfOverlay = showDiagnostics
  ? lazy(() => import('@/components/debug/PerfOverlay').then((m) => ({ default: m.PerfOverlay })))
  : () => null

const OfflineIndicator = lazy(() =>
  import('@/components/feedback/OfflineIndicator').then((m) => ({
    default: m.OfflineIndicator,
  })),
)

export function Root() {
  const { player } = usePlayer()

  return (
    <div className="wefa-root">
      <AppBar energy={player?.energy ?? 0} />
      <Suspense>
        <OfflineIndicator />
      </Suspense>
      <PageShell>
        <Outlet />
      </PageShell>
      {!kidFirstShellEnabled ? (
        <Suspense>
          <InstallBanner />
        </Suspense>
      ) : null}
      <BottomTabBar />
      {showDiagnostics && (
        <Suspense>
          <PerfOverlay />
        </Suspense>
      )}
    </div>
  )
}
